import Service from './Service';

export default class Categorization extends Service {

  list() {
    return this.axiosInstance.get(`/categorizations`);
  }

}
